import { render, staticRenderFns } from "./squareSkeleton.vue?vue&type=template&id=587f8401&"
import script from "./squareSkeleton.vue?vue&type=script&lang=js&"
export * from "./squareSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./squareSkeleton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports